export interface UploadResponse {
	filename: string;
	original_name: string;
	url: string;
}

async function processFileUploadResponse(response: Response): Promise<UploadResponse> {
	if (!response.ok) {
		throw new Error(`could not upload image: ${response.statusText}`);
	}

	const data = await response.json();
	return {
		...data,
		url: data.filename,
	};
}

function buildFormData(image: FileList | File) {
	const formData = new FormData();

	if (image instanceof FileList) {
		formData.append('file', image[0]);
	} else {
		formData.append('file', image);
	}

	return formData;
}

export async function UploadProfileImage(
	token: string | null,
	image: FileList | File,
): Promise<UploadResponse> {
	if (!token) {
		throw new Error('token is required');
	}
	const formData = buildFormData(image);
	const response = await fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/profile/upload`, {
		headers: {
			'bl-token': token,
		},
		method: 'POST',
		body: formData,
	});
	return processFileUploadResponse(response);
}

export async function UploadImage(
	token: string | null,
	image: FileList | File,
): Promise<UploadResponse> {
	if (!token) {
		throw new Error('token is required');
	}
	const formData = buildFormData(image);
	const response = await fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/upload-size/1080/1920`, {
		headers: {
			'bl-token': token,
		},
		method: 'POST',
		body: formData,
	});
	return processFileUploadResponse(response);
}
